module.exports = __webpack_public_path__ + "static/media/number1.0cbc367a.webp";